import { createIndexSizeError } from '../factories/index-size-error';
export var wrapAudioBufferCopyChannelMethodsSubarray = function wrapAudioBufferCopyChannelMethodsSubarray(audioBuffer) {
  audioBuffer.copyFromChannel = function (copyFromChannel) {
    return function (destination, channelNumber) {
      var startInChannel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (channelNumber >= audioBuffer.numberOfChannels || startInChannel >= audioBuffer.length) {
        throw createIndexSizeError();
      }

      if (startInChannel < audioBuffer.length && audioBuffer.length - startInChannel < destination.length) {
        return copyFromChannel.call(audioBuffer, destination.subarray(0, audioBuffer.length - startInChannel), channelNumber, startInChannel);
      }

      return copyFromChannel.call(audioBuffer, destination, channelNumber, startInChannel);
    };
  }(audioBuffer.copyFromChannel);

  audioBuffer.copyToChannel = function (copyToChannel) {
    return function (source, channelNumber) {
      var startInChannel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (channelNumber >= audioBuffer.numberOfChannels || startInChannel >= audioBuffer.length) {
        throw createIndexSizeError();
      }

      if (startInChannel < audioBuffer.length && audioBuffer.length - startInChannel < source.length) {
        return copyToChannel.call(audioBuffer, source.subarray(0, audioBuffer.length - startInChannel), channelNumber, startInChannel);
      }

      return copyToChannel.call(audioBuffer, source, channelNumber, startInChannel);
    };
  }(audioBuffer.copyToChannel);
};